"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.createExternalReducer = void 0;

/**
 * Create a reducer capable of being reset externally by dispatching the `reset` action
 * @param name
 * @param initialState
 * @return {{reducer: reducer, reset: (function(*): {type: string, state: *})}}
 */
var createExternalReducer = function (name, initialState) {
  if (initialState === void 0) {
    initialState = '';
  }

  var actionType = "RESET_STATE_" + name;

  var reducer = function (state, action) {
    if (state === void 0) {
      state = initialState;
    }

    switch (action.type) {
      case actionType:
        return action.state;

      default:
        return state;
    }
  };

  return {
    reducer: reducer,
    reset: function reset(state) {
      return {
        type: actionType,
        state: state
      };
    }
  };
};

exports.createExternalReducer = createExternalReducer;
var _default = createExternalReducer;
exports.default = _default;